import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { UtilityService } from 'src/app/services/utility.service';
import { ToastService } from 'src/app/services/toast.service';
import { UtilityStateResponse } from 'src/app/interfaces/responses/models';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponent } from 'src/app/shared/confirm-dialog/confirm-dialog.component';
import { UtilitiesEditComponent } from '../../utilities/utilities-edit/utilities-edit.component';
import { BaseComponent } from 'src/app/shared/base.component';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-configuration-panel',
  templateUrl: './configuration-panel.component.html',
  styleUrls: ['./configuration-panel.component.scss'],
})
export class ConfigurationPanelComponent extends BaseComponent implements OnInit {
  @Input() utility!: UtilityStateResponse;
  @Output() utilityUpdated = new EventEmitter<void>();

  id = '';
  selectedTab = 'userPermissions';

  constructor(
    private utilityService: UtilityService,
    private toastService: ToastService,
    private route: ActivatedRoute,
    private location: Location,
    private dialog: MatDialog
  ) {
    super();
  }

  ngOnInit(): void {
    this.id = this.route.snapshot.paramMap.get('id') || '';
    this.loadUtility();
  }

  loadUtility(): void {
    if (!this.id) return;
    this.utilityService.getUtility(this.id)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (data) => {
          this.utility = data;
        },
        error: (err) => {
          console.error('[ConfigurationPanel] Failed to load utility:', err);
          this.toastService.show('Failed to load utility details', 'error');
        }
      });
  }

  goBack(): void {
    this.location.back();
  }

  selectTab(tab: string): void {
    this.selectedTab = tab;
  }

  openEditUtilityModal(): void {
    if (!this.utility) {
      this.toastService.show('Utility data not loaded yet', 'error');
      return;
    }

    const dialogRef = this.dialog.open(UtilitiesEditComponent, {
      width: '1000px',
      maxHeight: '90vh',
      panelClass: 'custom-dialog-container',
      data: { utility: this.utility }
    });

    dialogRef.afterClosed()
      .pipe(takeUntil(this.destroy$))
      .subscribe(result => {
        if (result) {
          this.loadUtility();
          this.utilityUpdated.emit();
        }
      });
  }

  deleteUtility(): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'custom-dialog-container',
      data: {
        title: 'Delete Utility',
        message: 'Are you sure you want to delete this utility?'
      }
    });

    dialogRef.afterClosed()
      .pipe(takeUntil(this.destroy$))
      .subscribe(result => {
        if (result) {
          this.toastService.show('Delete functionality can be implemented here.', 'success');
        }
      });
  }
}